<template>
  <div class="block latestPostBlock">
    <v-container>
      <h2 class="text-center">Our Services</h2>
      <v-row>
        <v-col v-for="item in items" :key="item.id" cols="12" md="4">
          <v-card outlined class="mx-auto">
            <v-img
              class="white--text align-end"
              height="200px"
              :src="item.src"
            >
              <v-card-title>{{ item.title }}</v-card-title>
            </v-img>
            <v-card-subtitle class="pb-0">{{ item.subtitle }}</v-card-subtitle>
            <v-card-text class="text--primary">
              <div>{{ item.description }}</div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Service",
  data: () => ({
    show: false,
    items: [
      {
        id: 1,
        title: "Kitchen Design",
        subtitle: "Your opinion matters",
        description: `Our certified design team will sit down with you for a free initial consultation.
        With your needs in mind, the team will create a new floor plan that embraces your family’s lifestyle, ensuring aesthetics 
        as well as function. Our team will provide insightful suggestions based on their experience and expertise. In the end, 
        we hope to create a design that you love!`,
        src: require("../assets/images/services/img2.jpg")
      },
      {
        id: 2,
        title: "Custom Cabinetry",
        subtitle: "Your happiness is guaranteed",
        description: `Along with our elegant kitchen designs, we also pride ourselves on offering luxurious accents to other
           rooms in your home. We offer unique vanities, functional fireplace mantles, bookcases, bedroom and basement wall units, to name a few. 
           With both classical and traditional styles to modern and cutting-edge designs, we are here to meet your every need. `,
           src: require("../assets/images/services/img1.jpg")
      },
      {
        id: 3,
        title: "Space Planning",
        subtitle: "Count on our Experience",
        description: `Once a kitchen is designed, our contractors along with our design team will make a home visit. 
          We will then take measurements, adjust any necessary plans and begin the initial steps to create your dream kitchen. `,
          src: require("../assets/images/services/img12.jpg")
      }
    ]
  })
};
</script>